import Vue from 'vue'
import Vuex from 'vuex'
import { getConfig } from '@/api/config'
import { Message } from 'element-ui' // 引入 ElementUI 消息提示

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 系统全局配置（底部信息、网站标题等）
    sysConfig: {}
  },
  mutations: {
    // 设置底部配置
    SET_BOTTOM_CONFIG(state, data) {
      state.sysConfig = data || {}
    }
  },
  actions: {
    // 获取全局底部配置信息
    async getSysConfig({ commit }) {
      try {
        const res = await getConfig()
        
        // ✅ 正确判断：接口返回成功 且 数据不为空
        if (res.code === 200 && res.data) {
          commit('SET_BOTTOM_CONFIG', res.data)
        } 
        // ✅ 接口成功但没数据（不报错，只给默认空）
        else if (res.code === 200) {
          commit('SET_BOTTOM_CONFIG', {})
        }
        // ❌ 接口返回业务错误
        else {
          Message.warning({
            message: res.msg || '获取底部配置失败',
            duration: 2000
          })
        }
      } catch (error) {
        console.error('获取底部配置接口异常：', error)
        // ❌ 网络/服务器异常 → 弹出错误
        Message.error({
          message: '网络异常，获取底部配置失败！',
          duration: 2000
        })
      }
    }
  },
  getters: {
    sysConfig: state => state.sysConfig
  }
})